import clsx from 'clsx';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@material-ui/core';
import { AttachmentGateway } from 'shared/components/attachments/AttachmentGateway';
import { AttachmentsPreviewModal } from 'shared/components/attachments/AttachmentsPreviewModal';
import { loadAttachments } from 'shared/components/attachments/store/actions';
import { useUploadStyles } from 'shared/components/attachments/styles';
import { IAttachment } from 'shared/models/Attachments';
import { useModal } from 'shared/utils/hooks/useModal';

interface IAttachmentsPreviewProps {
    attachments: IAttachment[];
    onAttachmentRemove?: (file: IAttachment) => void;
    showModalFromCount?: number;
}

export const AttachmentsPreview = ({
    attachments,
    onAttachmentRemove,
    showModalFromCount = 0,
}: IAttachmentsPreviewProps) => {
    const classes = useUploadStyles();
    const dispatch = useDispatch();
    const {
        isModalOpened: isPreviewOpen,
        onModalOpen: onPreviewOpen,
        onModalClose: onPreviewClose,
    } = useModal();

    const firstAttachmentId = attachments[0]?.id;
    useEffect(() => {
        if (firstAttachmentId) {
            dispatch(loadAttachments.init(firstAttachmentId));
        }
    }, [dispatch, firstAttachmentId]);

    return (
        <>
            {(attachments.length > 0) && (
                <section className={classes.preview}>
                    <div className = {clsx(classes.filePreviewZone)}>
                        {attachments.length > 0 && (
                            <AttachmentGateway attachment={attachments[0]} />
                        )}
                        {(!showModalFromCount || attachments.length > showModalFromCount) && (
                            <Button
                                className = {classes.imageButton}
                                color="inherit"
                                onClick={onPreviewOpen}>
                                See All {`[${attachments.length}]`}
                            </Button>
                        )}
                    </div>
                </section>
            )}

            {(attachments.length > 0) && isPreviewOpen && (
                <AttachmentsPreviewModal
                    open={isPreviewOpen}
                    onClose={onPreviewClose}
                    files={attachments}
                    onDelete={onAttachmentRemove}
                />
            )}
        </>
    );
};
